export default __webpack_public_path__ + "static/media/section-heading-card.68befb66.svg";